import React, { CSSProperties, memo, useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import styled from "styled-components";

type Params = {
  className?: string;
  id?: string;
  initialValue: string;
  changed: (newVal: string) => void;
  readonly: boolean;
  borderAlways?: boolean;
  style?: CSSProperties;
};
const MyTextbox = memo((params: Params) => {
  const {
    className,
    id,
    initialValue,
    changed,
    readonly = false,
    borderAlways = false,
    style,
  } = params;
  const [text, setText] = useState("");

  useEffect(() => {
    setText(initialValue);
  }, [initialValue]);

  return (
    <SFormText
      className={`${className} ${borderAlways && "borderAlways"}`}
      style={style}
      id={id}
      type="text"
      value={text}
      title={text}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        setText(e.target.value);
        changed(e.target.value);
      }}
      readOnly={readonly}
    />
  );
});

export default MyTextbox;

const SFormText = styled(Form.Control)`
  line-height: 1.2;
  :read-only {
    :not(.borderAlways) {
      border: none;
    }
    background-color: transparent;
  }
  text-overflow: ellipsis;
`;
